<script setup>
import Header from '../components/web/header.vue'
import Content from './content.vue'
import { ref, onBeforeMount } from 'vue'
import { getRecruit } from '@/api/2024/index'

let pageDate = ref({})
let pageId = ref('Z1FlNFkzRWxybVEzQmdZNmpXTm1aUT09Ojogynm9rzh5Ja8AjEb4e/6r')

onBeforeMount(async () => {
  await fetch()
})

const fetch = () => {
  getRecruit(pageId.value)
    .then((res) => {
        pageDate.value = JSON.parse(res.data.data.data)
    })
    .catch(() => {})
}

</script>
<script>

</script>
<template>
    <div class="baiqiang-page">
        <Header :data="pageDate.headerInfo"/>
        <Content :data="pageDate"/>
    </div>
</template>
<style lang="scss" scoped>
.baiqiang-page{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: rgb(247, 248, 250);
}
</style>
